import React from 'react';
import { motion } from 'framer-motion';
export function FloatingWhatsApp() {
  const whatsappUrl = 'https://api.whatsapp.com/send/?phone=84869812254&text&type=phone_number&app_absent=0';
  return <motion.a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 left-6 z-50 flex items-center justify-center group" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    type: 'spring',
    stiffness: 260,
    damping: 20,
    delay: 1
  }} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} data-id="element-123">
      {/* Main Icon Container */}
      <div className="relative" data-id="element-124">
        {/* Subtle pulse ring */}
        <div className="absolute inset-0 rounded-full bg-[#D4A574] opacity-20 group-hover:animate-ping" data-id="element-125" />

        {/* Professional Icon */}
        <div className="relative w-16 h-16 rounded-full bg-white shadow-2xl flex items-center justify-center border-2 border-[#D4A574]/20 transition-all duration-300 group-hover:shadow-[0_10px_40px_rgba(212,165,116,0.4)]" data-id="element-126">
          <img src="https://cdn.magicpatterns.com/uploads/angiCSYzRSstxdq2Yi5PjQ/contact-icon-illustration-isolated_23-2151903347.png" alt="Contact Us" className="w-12 h-12 object-contain" data-id="element-127" />
        </div>

        {/* Professional Tooltip Badge */}
        <div className="absolute left-full ml-3 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none" data-id="element-128">
          <div className="bg-gradient-to-r from-[#D4A574] to-[#C9964A] text-white px-4 py-2.5 rounded-full shadow-xl flex items-center gap-2 whitespace-nowrap" data-id="element-129">
            <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm" data-id="element-130">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-131">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-132" />
              </svg>
            </div>
            <span className="font-semibold text-sm" data-id="element-133">+84 96 981 2254</span>
          </div>
          {/* Arrow */}
          <div className="absolute right-full top-1/2 -translate-y-1/2 border-8 border-transparent border-r-[#D4A574]" data-id="element-134" />
        </div>
      </div>
    </motion.a>;
}